<div class="room" [ngClass]="{'active': active}">
  <div class="room__wrapper">
    <div class="room__image-box">
      <div class="image" [style.background-color]="title | firstLetters | avatarColor"><span>{{title | firstLetters}}</span></div>
      <div class="status" [ngClass]="status"></div>
    </div>
    <div class="room__info">
      <div class="title-box">
        <div class="title">{{title}}</div>
        <div class="date" *ngIf="date">{{date | dateMessageNew}}</div>
      </div>
      <div class="info-box">
        <div class="text" *ngIf="text">{{text}}</div>
        <div class="new" *ngIf="isNew"></div>
      </div>

    </div>
  </div>
</div>
